import { render, staticRenderFns } from "./Shield.vue?vue&type=template&id=5c3a604a&"
import script from "./Shield.vue?vue&type=script&lang=js&"
export * from "./Shield.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports